import { WarningOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React, { FunctionComponent, ReactNode } from 'react';
import { AutomationTemplateContainer } from '../../../AutomationTemplateContainer';
import styles from './TemplateBuilderComponents.module.css';

interface Props {
  children: ReactNode;
}

export const TemplateBuilderReengagementSection: FunctionComponent<Props> = ({
  children,
}) => {
  const { smsDisableReason } = AutomationTemplateContainer.useContainer();
  return (
    <div
      className={classNames(
        styles.subsection,
        styles.reengagementAutomationContainer,
        {
          [styles.reengagementAutomationContainer__disabled]: smsDisableReason,
        },
      )}
    >
      <div className={styles.subsectionHeading}>Re-Engagement Automation</div>
      {smsDisableReason && (
        <div className={styles.reengagementAutomationContainerDisableReason}>
          <WarningOutlined /> {smsDisableReason}
        </div>
      )}
      {children}
    </div>
  );
};
